<!-- SchedulerNavigation.vue -->
<template>
	<div class="navigation-track-fixed">
		<div class="navigation-content justify-space-between mr-4">
			<div class="d-flex">
				<IconButton
					class="mr-1"
					icon="mdi-chevron-left"
					iconColor="black"
					buttonSize="28"
					size="14"
					:disabled="!canGoPreviousMonth"
					@click="$emit('navigate', -1)"
				/>
				<IconButton
					class="mr-2"
					icon="mdi-chevron-right"
					iconColor="black"
					buttonSize="28"
					size="14"
					:disabled="!canGoNextMonth"
					@click="$emit('navigate', 1)"
				/>
			</div>
			<div class="d-flex">
				<v-btn
					flat
					variant="tonal"
					size="small"
					height="26"
					class="text-capitalize text-caption font-weight-bold px-3 mr-2"
					:disabled="isTodayDisabled"
					@click="$emit('go-today')"
				>
					{{ $t('today') }}
				</v-btn>
				<IconButton icon="mdi-cog" iconColor="black" buttonSize="28" size="16" @click="$emit('toggle-panel')" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import IconButton from '@/rennovation/planning-view/components/Controls/IconButton.vue';

defineProps<{ canGoPreviousMonth: boolean; canGoNextMonth: boolean; isTodayDisabled: boolean; currentMonth: string }>();
defineEmits(['navigate', 'go-today', 'toggle-panel']);
</script>

<style lang="scss" scoped>
.navigation-track-fixed {
	flex-grow: 1;
	background-color: white;
	height: 100%;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #e2e8f0;
}

.navigation-content {
	display: flex;
	align-items: center;
	padding-left: 16px;
	color: black;
	height: 100%;
	width: 100%;
}
</style>
